const microServices = {
    USER_SERVICE: "/user-service/api",
  };
  export const endpoints = {
    SUPER_ADMIN_ACCOUNTS_SUMMARY_COUNT: `${microServices.USER_SERVICE}/super-admin/admin-analytics/accounts-summary-count`,
    SUPER_ADMIN_GROUP_WISE_ACCOUNTS_COUNT: `${microServices.USER_SERVICE}/super-admin/admin-analytics/get-group-wise-accounts-count`,
  };
  